import { FlexCol, FlexJustifySpaceBetween } from 'components/primitives/flex';
import { dollarsWithCentsWithSymbol } from 'helpers/currency';
import styled from 'styled-components';
import { useTripCalculator } from 'hooks/queries';
import { PricingSection, Fees } from './shared';

export default () => {
  const { tripCalculation } = useTripCalculator();

  return (
    <PricingSection gap="5px">
      <MessageOwnerPricing>
        <FlexCol>
          <div className="total">Booking total</div>
          <Fees>Additional fees will show at checkout</Fees>
        </FlexCol>
        <div className="totalAmount">
          {dollarsWithCentsWithSymbol(tripCalculation?.pre_tax_and_fees_booking_total || 0)}
        </div>
      </MessageOwnerPricing>
    </PricingSection>
  );
};

const MessageOwnerPricing = styled(FlexJustifySpaceBetween)`
  padding-bottom: 15px;

  .total {
    font-weight: 600;
  }

  .totalAmount {
    font-size: 18px;
    font-weight: 700;
  }
`;
